import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BbitWebShopAlgoliaService } from '@bbitgmbh/webshop.sdk';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BehaviorSubject, mergeMap, Subject, skip, takeUntil } from 'rxjs';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  imports: [ReactiveFormsModule, FormsModule, NgIcon, AsyncPipe, I18nPipe],
})
export class SearchBoxComponent implements OnDestroy {
  algolia = inject(BbitWebShopAlgoliaService);
  private _router = inject(Router);

  public query = new BehaviorSubject('');
  private _ngUnsubscribe = new Subject<void>();

  constructor() {
    this.algolia
      .observeQuery()
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe((data) => {
        if (data !== this.query.value) {
          this.query.next(data);
        }
      });

    this.query
      .pipe(
        skip(2), // skip initial value and first trigger from algolia
        mergeMap(async (query: string) => {
          this.algolia.query(query);
          if (!this._router.url?.startsWith('/shop/items')) {
            this._router.navigate(['/shop/items'], { queryParamsHandling: 'merge' });
          }
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }

  reset() {
    this.algolia.query('');
  }
}
